export const environment = {
    production: true,
    databet: {
        boodstrap: "https://spa.databet.cloud/v2/project-name/bootstrap.js"
    },
    luckyFishTheme: {
        font: {
            fontSans: "Roboto, sans-serif",
            baseFontSize: "16px"
        },
        palette: {
            colorsPrimary1: "#ffffff !important",
            colorsPrimary2: "#00262c !important",
            colorsSecondary1: "#00383f !important",
            colorsSecondary2: "#0b4951 !important",
            colorsSecondary3: "#4c8890 !important",
            colorsAccent1: "#ffd700 !important",
            colorsAccent2: "#ffd700 !important",
            colorsAccent3: "#ffd600 !important",
            colorsSportIcons: "#adc5c8 !important",
            textButton: "#17171c !important",
            textPrimary: "#ffffff !important",
            textSecondary: "#b0cacd !important",
            textOdd: "#ffd700 !important",
            notificationBlocked: "#2f6d75 !important",
            notificationError: "#ee202e !important",
            notificationInfo: "#0484c0 !important",
            notificationSuccess: "#1fa856 !important",
            notificationWarning: "#fff500 !important",
            betslipCTABtnBg: "#ffd600 !important",
            betslipCTABtnText: "#000000 !important",
            text: "#ffffff !important",
        },
        radius:
        {
            rounded2: "2px",
            rounded4: "4px",
            rounded6: "6px",
            rounded8: "8px",
            rounded12: "12px",
            rounded24: "24px"
        },
        offsetTop: 16
    },
    luckyFishProject: '1e642752'
};